import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactGa from 'react-ga';
import colors from '../../utils/colors';
import BaseButton from '../baseButton';

const Title = styled.h1`
  font-size: 4em;
  margin-top: 6rem;
  align-self: center;
  text-align: center;
  color: ${colors.primaryText};
`;

const MainContainer = styled.div`
  background-color: ${colors.grey[1]};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding-bottom: 150px;
`;

const StartButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.primaryText};

  &:h5 {
    margin-bottom: 20px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  max-width: 650px;
  margin-top: 100px;
  color: ${colors.primaryText};
`;

const Header = styled.h2`
  max-width: 400px;
  margin-bottom: 20px;
`;

const Landing = () => {
  const history = useHistory();

  const startGame = () => {
    ReactGa.event({
      category: 'Play',
      action: 'Navigated to /play',
    });
    const path = 'play';
    history.push(path);
  };

  const { isStarted } = useSelector((state) => state.settings);

  const ButtonText = isStarted ? 'Continue' : 'Start';

  return (
    <MainContainer>
      <Title>Diablo3 Roguelite</Title>
      <StartButtonContainer>
        <BaseButton onClick={startGame} text={ButtonText} />
      </StartButtonContainer>
      <TextContainer>
        <Header>Welcome to a new way to experience Diablo 3</Header>
        <p>- Did you like the challenge on Inferno in vanilla Diablo 3?</p>
        <p>
          - Do you miss the good old days when Diablo 3 was more randomized and
          difficulty curved up way too steep?
        </p>
        <p>We think that too!</p>
        <p>
          Welcome to Diablo 3 Roguelite, a meta game where pretty much nothing
          is easy.
        </p>
      </TextContainer>
      <TextContainer>
        <Header>Prepare to die by the rules</Header>
        <p>
          This game is designed to be played alongside Diablo 3, to make the
          game harder and more interesting with randomized rules.
        </p>
        <p>
          Before you start the game, please check the base rules and guidelines
          below that should be followed to make the most of this game.
        </p>
      </TextContainer>
      <TextContainer>
        <Header>Base rules and guidelines</Header>
        <p>
          Here&apos;s some basic rules that applies to all games played with
          this rule set. Although following rules are somewhat strict and for
          legimitely completing this minigame forces to follow them, you can
          always alter your gameplay however you like. It&apos;s all about
          having fun after all
        </p>
        <ul>
          <li>
            Game is meant to be played in seasons on hardcore starting from
            scratch (fresh season). In solo play you play alone, so no help from
            friends. In multiplayer you can loot share, but all players should
            play same content so no split bounties etc. You can switch to
            another server if you play seasons on hardcore also normally. You
            can also play in regular hardcore if you don&apos;t want to reset
            your stash, gold and other achievements every season, but
            that&apos;s not ideal.
          </li>
          <li>
            Game is played on total 8 phases. Follow the phase instructions. You
            can complete the phase goals to get tokens. You can use tokens to
            reroll your rules.
          </li>
          <li>
            Do not grind gear after Phase 7, just go straight to phase goal in
            phase 8.
          </li>
          <li>
            Do not use paragon points. In this gamemode we do not want players
            to grind paragon points for infinite power increase. It should be
            constant battle for survivability.
          </li>
          <li>
            Do not use challenge rift cache. If you want money, materials, blood
            shards and / or bounty materials, grind them.
          </li>
          <li>
            Disable auto equip. You don&apos;t want to accidently equip
            something you&apos;re not allowed
          </li>
        </ul>
      </TextContainer>
      <TextContainer>
        <Header>Give us feedback</Header>
        <p>
          Goals for us at this point is to play by the rules and check if they
          are reasonable, yet hard. It is not meant to be completed by one go.
          Prepare to die 10+ times before completing this minigame even on
          normal difficulty. There should not be any single rule that completely
          ruins one gameplay. More likely there can be set of rules that
          together make one gameplay nearly impossible.
        </p>
        <p>
          If you find bugs on the site or want to give us feedback about this
          minigame, please contact d3roguelite(at)gmail.com or join our{' '}
          <a href="https://discord.gg/AdV9eJ9">Discord</a> server.
        </p>
      </TextContainer>
      <TextContainer>
        <Header>Future updates and what we are working on</Header>
        <p>
          This minigame website is still in development and here&apos;s some
          things we are currently working on now and in the future.
        </p>
        <ul>
          <li>Support for small screen sizes (mobile, etc)</li>
          <li>Leaderboards system??</li>
        </ul>
        <p>
          The mini game is in constant development. Checkout our discord server
          for recent updates.
        </p>
      </TextContainer>
    </MainContainer>
  );
};

export default Landing;
